// Mirrors extractUserPrompt in src/node/services/kaizen/userPromptMessage.ts.
// Prompt-first format: `User prompt: <text>\n\n<context>\n...\n</context>`.
const promptFirstRegex = /^User prompt: ?([\s\S]*)\n\n<context>\n[\s\S]*<\/context>$/;
// Older context-first format: `Context:\n...\n\nUser prompt: <text>`.
const contextFirstRegex = /User prompt:\s*(.*?)$/s;

export const extractUserPrompt = (messageText) => {
  const match = messageText.match(promptFirstRegex) || messageText.match(contextFirstRegex);
  return match ? match[1].trim() : messageText;
};
